module.exports = __webpack_public_path__ + "static/media/closeMenu.25f1ffe3.svg";